import styles from './date-nav.module.scss'

type Props = {
  label: string
  onPrev: () => void
  onNext: () => void
  onToday: () => void
  isAtToday: boolean
}

export function DateNav({ label, onPrev, onNext, onToday, isAtToday }: Props) {
  return (
    <div className={styles.nav}>
      <button
        type="button"
        className={styles.chevron}
        aria-label="Previous range"
        onClick={onPrev}
      >
        ‹
      </button>
      <span className={`${styles.label} mono`}>{label}</span>
      <button
        type="button"
        className={styles.chevron}
        aria-label="Next range"
        onClick={onNext}
      >
        ›
      </button>
      <button
        type="button"
        className={styles.today}
        onClick={onToday}
        disabled={isAtToday}
      >
        Today
      </button>
    </div>
  )
}
